var modules_c1e2d868 = {"root":"CardSummary_module_root__fe8b28ea","label":"CardSummary_module_label__fe8b28ea","tooltip":"CardSummary_module_tooltip__fe8b28ea","value":"CardSummary_module_value__fe8b28ea"};
import "../../../../../assets/esm/components/OfferCard/CardWide/components/CardSummary/CardSummary~BkUg_Lur.css";

export { modules_c1e2d868 as default };
//# sourceMappingURL=CardSummary.module.scss.js.map
